// Added by Jonghyung Lee on 2021-09-23
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { useState } from 'react'
import {
  Collapse as MaterialCollapse,
  CollapseProps as MaterialCollapseProps,
  createStyles,
  makeStyles,
  Theme,
} from '@material-ui/core'
import { ExpandLessIcon, ExpandMoreIcon, Typography } from '@/components/_primes'

interface CollapseProps extends MaterialCollapseProps {
  title?: string
  initialOpen?: boolean
}

export default function Collapse({ title = 'No title', initialOpen = true, ...props }: CollapseProps) {
  const [expanded, setExpanded] = useState<boolean>(initialOpen)

  const classes = useStyles()
  return (
    <>
      <div className={classes.formTitle}>
        <Typography className={classes.title} variant='h1'>
          {title}
        </Typography>
        <div className={classes.ctrWrapper} onClick={() => setExpanded(!expanded)}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </div>
      </div>
      <MaterialCollapse timeout={'auto'} in={expanded} {...props} />
    </>
  )
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      paddingRight: `${theme.spacing()}px`,
    },
    formTitle: {
      paddingBottom: 0,
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: `${theme.spacing() * 2}px`,
    },
    ctrWrapper: {
      color: '#fff',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      fontSize: '1.5rem',
    },
  })
)
